import { Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EditManualBankAccountFormBody } from './elements/EditManualBankAccountFormBody'
import { EditManualBankAccountFormFooter } from './elements/EditManualBankAccountFormFooter'
import { EditManualBankAccountModalState } from './enums/editManualBankAccountModalState'
import { useEditManualBankAccountForm } from './hooks/useEditManualBankAccountForm'

interface EditManualBankAccountModalProps extends ModalProps {
  accountId: string | undefined
  bankAccountId: string | undefined
  state: EditManualBankAccountModalState
  onSuccess?: (accountId: string) => void
}

export const EditManualBankAccountModal = ({
  id,
  accountId,
  bankAccountId,
  state,
  onSuccess,
}: EditManualBankAccountModalProps): ReactElement => {
  const { t } = useTranslation()
  const form = useEditManualBankAccountForm({ id, accountId, bankAccountId, state, onSuccess })

  return (
    <Modal id={id} size="s">
      <Modal.Header title={accountId ? t('bank.account.modal.header.edit') : t('bank.account.modal.header.create')} />
      <Modal.Body>
        <EditManualBankAccountFormBody form={form} />
      </Modal.Body>
      <Modal.Footer>
        <EditManualBankAccountFormFooter form={form} />
      </Modal.Footer>
    </Modal>
  )
}
